module.exports = __webpack_public_path__ + "img/sfmd3.a176a631.jpg";